<template>
  <section class="flex items-center mb-3 mb:mb-5 pt-2 w-full md:col-span-full md:col-start-1">
    <h2 v-show="!overlayStore.loader" class="shrink-0 mr-3 text-app-green text-sm md:text-lg font-semibold" :class="{ 'opacity-50': !isReady }">
      {{ isReady ? count : '...' }} {{ title }}
    </h2>
    <div v-show="!orderByLocation" class="flex items-center ml-auto">
      <label class="mr-3 text-xs sm:text-sm font-semibold sm:block text-black">{{ $t('animal.overview.sort') }}</label>
      <FormKit
        v-model="choiceValue"
        outer-class="!mb-0"
        inner-class="bg-white"
        type="select"
        :title="$t('animal.overview.sort')"
        :options="[
          { value: 'DESC', label: $t('search.filters.new.desc') },
          { value: 'ASC', label: $t('search.filters.long-stay.asc') },
        ]"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useOverlayStore } from '~/store/overlay'

interface Props {
  orderByLocation: boolean
  count: number
  title: string
  orderByDate: string
  isReady?: boolean
}

const props = defineProps<Props>()
const emit = defineEmits(['valueUpdate'])

const overlayStore = useOverlayStore()

const choiceValue = ref(props.orderByDate)
watch(choiceValue, (newValue) => {
  // do a check for valid or isNan of number type
  emit('valueUpdate', newValue)
})
</script>
